import React, { useEffect, useState } from "react";

const KEY = "intro-seen";
const seenThisSession = () => {
  try {
    return window.sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

const IntroLoader = () => {
  // Show the intro once per browser session, not on every page load.
  const [gone, setGone] = useState(seenThisSession);
  const [out, setOut] = useState(false);

  useEffect(() => {
    // `gone` is decided once from the initial state, so StrictMode's double
    // effect run in development cannot skip the timers.
    if (gone) return undefined;
    try {
      window.sessionStorage.setItem(KEY, "1");
    } catch {
      /* private mode: just show it again next time */
    }
    const t1 = setTimeout(() => setOut(true), 1700);
    const t2 = setTimeout(() => setGone(true), 2400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [gone]);

  if (gone) return null;

  return (
    <div className={`intro-loader ${out ? "is-out" : ""}`}>
      <div className="flex flex-col items-center gap-5">
        <div className="text-xs uppercase tracking-[0.4em] text-white/55">
          Hamza Mehboob
        </div>
        <div className="intro-bar" />
        <div className="text-[10px] uppercase tracking-[0.32em] text-white/35">
          Loading experience
        </div>
      </div>
    </div>
  );
};

export default IntroLoader;
